import { useAnalytics } from 'hx-analytics';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { trackCustom } from '@/events/hooks/use-eargo-event.hook';
export function useTrackTestStart() {
    var rootState = useSelector(function (state) { return state; });
    var _a = useAnalytics(rootState), sendButtonClick = _a.sendButtonClick, sendCustomAnalytics = _a.sendCustomAnalytics;
    var searchParams = useSearchParams()[0];
    function trackTestStart() {
        sendButtonClick('widget_started');
        var attribution = {};
        searchParams.forEach(function (value, key) { return (attribution[key] = value); });
        sendCustomAnalytics({ type: 'test-start', attribution: attribution });
        trackCustom('test_start', { attribution: attribution });
    }
    return { trackTestStart: trackTestStart };
}
